import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';

@Injectable({ providedIn: 'root' })
export class FetchUserNewsletterEnabledApiQuery extends ApiQuery<
	boolean,
	void
> {
	client = 'messaging';
	document = gql`
		query FetchUserNewsletterEnabled {
			fetchUserNewsletterEnabled
		}
	`;
	method = 'fetchUserNewsletterEnabled';
}
